import { type DeprecatedDoerRouteConfig } from "./deprecatedRoutePageIdTypes";

// removed features with preserved links/routes
const removedDoerOnlyCustomerRoutes: DeprecatedDoerRouteConfig[] = [
  {
    pageId: "bettercloud-asset-create-2",
    route: "/customers/:customerId/assets/bettercloud/create",
  },
  {
    pageId: "zendesk-asset-create-2",
    route: "/customers/:customerId/assets/zendesk/create",
  },
];

export const deprecatedDoerRoutes: DeprecatedDoerRouteConfig[] = [
  ...removedDoerOnlyCustomerRoutes,
  {
    pageId: "known-issues-2",
    route: "/known-issues",
  },
  {
    pageId: "known-issues:details-2",
    route: "/known-issues/:knownIssueId",
  },
];
